<!-- Toggler -->
<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarCollapse"
        aria-controls="sidebarCollapse" aria-expanded="false">
    <span class="navbar-toggler-icon"></span>
</button>

<!-- Brand -->
<a class="navbar-brand" [routerLink]="'/'">
    <img [src]="'/assets/images/logos/' + appContext.brand + '-logo-500.png'" class="navbar-brand-img mx-auto" alt="Logo">
</a>

<!-- User (xs) -->
<div class="navbar-user d-md-none">

    <!-- Dropdown -->
    <div class="dropdown">

        <!-- Toggle -->
        <a href="#" id="sidebarIcon" class="dropdown-toggle notranslate" role="button" data-bs-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
            <div class="avatar avatar-sm avatar-online position-relative">
                <span class="avatar-title rounded-circle">{{ appContext.initials }}</span>
                <ng-container *ngIf="appContext.isAdminOrIntermediary()">
                    <ng-container *ngIf="edsnDisconnectedAlerts | async as alerts">
                        <span *ngIf="alerts.length"
                              class="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-danger notranslate">
                            1
                        </span>
                    </ng-container>
                </ng-container>
            </div>
        </a>

        <!-- Menu -->
        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="sidebarIcon">
            <ng-template [ngTemplateOutlet]="edsnAlertsTemplate"></ng-template>
            <a routerLink="/profile" class="dropdown-item">Profile</a>
            <button *ngIf="appContext.isAdmin()" class="dropdown-item" (click)="openEncrypt()">Encrypt</button>
            <button *ngIf="appContext.impersonator" class="dropdown-item" (click)="stopImpersonatingUser()">Stop
                impersonating
            </button>
            <app-language-selector></app-language-selector>
            <hr class="dropdown-divider">
            <button class="dropdown-item" (click)="authService.signOut()">Logout</button>
        </div>

    </div>

</div>

<!-- Collapse -->
<div class="collapse navbar-collapse" id="sidebarCollapse">

    <!-- Form -->
    <form class="mt-4 mb-3 d-md-none">
        <div class="input-group input-group-rounded input-group-merge input-group-reverse">
            <input class="form-control" type="search" placeholder="Search" aria-label="Search">
            <div class="input-group-text">
                <span class="fe fe-search"></span>
            </div>
        </div>
    </form>

    <!-- Navigation -->
    <ul class="navbar-nav">
        <li class="nav-item">
            <a class="nav-link" href="#sidebarDashboards" data-bs-toggle="collapse" role="button" aria-expanded="true"
               aria-controls="sidebarDashboards">
                <img src="assets/images/icons/portfolio.svg" alt="Portfolio icon" width="15" height="15" class="me-2"/>
                Portfolio
            </a>
            <div class="collapse show" id="sidebarDashboards">
                <ul class="nav nav-sm flex-column">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link">Default</a>
                    </li>
                    <li *ngFor="let dashboard of getDashboardsForType(); trackBy : trackBy"
                        class="nav-item notranslate">
                        <a [routerLink]="'/dashboard/' + encoded(dashboard)" class="nav-link">
                            <span>{{ dashboard.info.name }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
        <li class="nav-item">
            <a routerLink="/reports" class="nav-link">
                <i class="bi bi-file-earmark-bar-graph me-2"></i>
                Reports
            </a>
        </li>
        <ng-container *ngIf="showLegacyReports">
            <li class="nav-item">
                <a class="nav-link" href="#sidebarReports" data-bs-toggle="collapse" role="button" aria-expanded="true"
                   aria-controls="sidebarReports">
                    <i class="bi bi-file-earmark-bar-graph me-2"></i>
                    Reports
                </a>
                <div class="collapse show" id="sidebarReports">
                    <ul class="nav nav-sm flex-column">
                        <li class="nav-item">
                            <a routerLink="/report-old/default" class="nav-link">{{ defaultReport.info.name }}</a>
                        </li>
                        <li *ngFor="let report of reports" class="nav-item notranslate">
                            <a [routerLink]="'/report-old/' + report.reportId" class="nav-link">
                                <i *ngIf="reportUtils.schedulingEnabled(report)" class="bi bi-clock me-2"
                                   data-bs-toggle="tooltip" data-bs-placement="top"
                                   [title]="(reportUtils.cronToFrequency(report.info.scheduleCron) | titlecase) + ' scheduled'"></i>
                                {{ report.info.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ng-container>

        <li class="nav-item" *ngIf="appContext.isAdminOrIntermediary()">
            <a class="nav-link" href="#monitoring" data-bs-toggle="collapse" role="button" aria-expanded="true"
               aria-controls="monitoring">
                <img src="assets/images/icons/portfolio.svg" alt="Portfolio icon" width="15" height="15" class="me-2"/>
                Monitoring
            </a>
            <div class="collapse show" id="monitoring">
                <ul class="nav nav-sm flex-column">
                    <li class="nav-item" *ngIf="appContext.isAdminOrIntermediary()">
                        <a routerLink="/alerts" class="nav-link">
                            <i class="bi bi-bell me-2"></i>
                            <span>Alerts</span>
                            <ng-container *ngIf="openAlerts | async as alerts">
                                <span *ngIf="alerts.length as alertCount" class="badge rounded-pill text-bg-danger ms-2 notranslate">
                                    {{ alertCount }}
                                </span>
                            </ng-container>
                        </a>
                    </li>

                    <li class="nav-item" *ngIf="appContext.isAdmin()">
                        <a routerLink="/issues" class="nav-link">
                            <i class="bi bi-exclamation-triangle me-2"></i>
                            <span>Errors</span>
                            <ng-container *ngIf="openErrors | async as errors">
                                <span *ngIf="errors.length as errorsCount" class="badge rounded-pill text-bg-danger ms-2 notranslate">
                                    {{ errorsCount }}
                                </span>
                            </ng-container>
                        </a>
                    </li>

                </ul>
            </div>
        </li>


        <li class="nav-item">
            <a class="nav-link" href="#configuration" data-bs-toggle="collapse" role="button" aria-expanded="true"
               aria-controls="configuration">
                <i class="bi bi-gear me-2"></i>
                Configuration
            </a>
            <div class="collapse show" id="configuration">
                <ul class="nav nav-sm flex-column">
                    <li class="nav-item">
                        <a routerLink="/organisations" class="nav-link">
                            <i class="bi me-2" [ngClass]="appContext.getIconOfSourceType('organisation')"></i>
                            Organisations
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/locations" class="nav-link">
                            <i class="bi me-2" [ngClass]="appContext.getIconOfSourceType('location')"></i>
                            Locations
                        </a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/connections" class="nav-link">
                            <i class="bi bi-speedometer2 me-2"></i>
                            Connections
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="appContext.isAdminOrIntermediary()">
                        <a routerLink="/contracts" class="nav-link">
                            <i class="bi bi-clipboard-check me-2"></i>
                            Contracts
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="appContext.isAdminOrIntermediary()">
                        <a routerLink="/taxes" class="nav-link">
                            <i class="bi bi-calculator me-2"></i>
                            Taxes
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="appContext.isAdminOrIntermediary()">
                        <a routerLink="/users" class="nav-link">
                            <i class="bi me-2" [ngClass]="appContext.getIconOfSourceType('user')"></i>
                            Users
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div> <!-- / .navbar-collapse -->

<!-- User (md) -->
<div class="navbar-user d-none d-md-flex align-items-center" id="sidebarUser">
    <app-language-selector class="me-2"></app-language-selector>
    <div style="width: 40px;">
        <!-- Dropup -->
        <div class="dropup">
            <!-- Toggle -->
            <a href="#" id="sidebarIconCopy" class="dropdown-toggle notranslate" role="button"
               data-bs-toggle="dropdown" data-bs-offset="100,20" data-bs-display="static"
               aria-haspopup="true" aria-expanded="false">
                <div class="avatar avatar-sm avatar-online position-relative">
                    <span class="avatar-title rounded-circle">{{ appContext.initials }}</span>
                    <ng-container *ngIf="appContext.isAdminOrIntermediary()">
                        <ng-container *ngIf="edsnDisconnectedAlerts | async as alerts">
                            <span *ngIf="alerts.length"
                                  class="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-danger notranslate">
                                1
                            </span>
                        </ng-container>
                    </ng-container>
                </div>
            </a>
            <!-- Menu -->
            <div class="dropdown-menu" aria-labelledby="sidebarIconCopy" data-bs-popper="static">
                <ng-template [ngTemplateOutlet]="edsnAlertsTemplate"></ng-template>
                <a routerLink="/profile" class="dropdown-item">Profile</a>
                <button *ngIf="appContext.isAdmin()" class="dropdown-item" (click)="openEncrypt()">Encrypt</button>
                <button *ngIf="appContext.impersonator" class="dropdown-item" (click)="stopImpersonatingUser()">Stop impersonating</button>
                <hr class="dropdown-divider">
                <button class="dropdown-item" (click)="authService.signOut()">Logout</button>
            </div>
        </div>
    </div>
</div>

<ng-template #edsnAlertsTemplate>
    <ng-container *ngIf="appContext.isAdminOrIntermediary()">
        <ng-container *ngIf="edsnDisconnectedAlerts | async as alerts">
            <div *ngIf="alerts.length">
                <a routerLink="/alerts"
                   [queryParams]="edsnDisconnectedAlertsQueryParams()"
                   class="dropdown-item d-flex align-items-start py-3">
                    <i class="bi bi-exclamation-triangle me-2"></i>
                    <span class="d-flex flex-column">
                        <span class="fw-semibold">EDSN disconnected alerts</span>
                        <span class="small text-muted">
                            <span class="notranslate">{{ alerts.length }} </span>
                            <span *ngIf="alerts.length === 1">alert from the past week</span>
                            <span *ngIf="alerts.length !== 1">alerts from the past week</span>
                        </span>
                    </span>
                </a>
            </div>
            <hr class="dropdown-divider" *ngIf="alerts.length">
        </ng-container>
    </ng-container>
</ng-template>
